"use client";

import dynamic from "next/dynamic";
const LazyMap = dynamic(() => import("./SpecificLocationMap"), {
  ssr: false,
  loading: () => <div className="relative w-full h-full">
      <div className="absolute inset-0 flex items-center justify-center bg-muted"></div>
    </div>
});
function SpecificLocationMapCaller(props: any) {
  return <LazyMap {...props} data-sentry-element="LazyMap" data-sentry-component="SpecificLocationMapCaller" data-sentry-source-file="SpecificLocationMapCaller.tsx" />;
}
export default SpecificLocationMapCaller;